/* eslint-disable */
import React from 'react';
// import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function HealthcareBanner() {
    return (
        <>
            <div className="banner">
                <img
                    src='../../assets/images/Health.jpg'
                    alt="Virtual assistant supporting healthcare professionals"
                    title="Healthcare Virtual Assistant Services by ConnectMyVA"
                    className="bannerImage"
                />			
            </div>	
        </>
    );
}

export default HealthcareBanner;
